var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreePalm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TreePalm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M17.7113 3.75C16.9539 3.75236 16.2049 3.9095 15.5104 4.21178C14.8159 4.51406 14.1905 4.95509 13.6726 5.50781C12.591 6.65463 11.9921 8.17363 12.0001 9.75L21.7501 5.50781C21.2322 4.95505 20.6068 4.51399 19.9123 4.2117C19.2178 3.90942 18.4688 3.7523 17.7113 3.75Z",
    fill: "#3C782C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.2,
    d: "M16.5525 9.20461C15.0161 8.79344 13.3794 9.00713 12 9.79899L20.7947 16.5002C20.9994 15.7446 21.0519 14.9559 20.949 14.1798C20.8462 13.4037 20.5901 12.6558 20.1956 11.9796C19.8007 11.3002 19.2756 10.7054 18.6505 10.2292C18.0254 9.75302 17.3124 9.40484 16.5525 9.20461Z",
    fill: "#3C782C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.2,
    d: "M10.3275 5.50761C9.81104 4.95307 9.18591 4.51083 8.49106 4.20844C7.79622 3.90606 7.04654 3.75 6.28875 3.75C5.53096 3.75 4.78129 3.90606 4.08644 4.20844C3.39159 4.51083 2.76646 4.95307 2.25 5.50761L12 9.74979C12.008 8.17342 11.4091 6.65443 10.3275 5.50761Z",
    fill: "#3C782C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.2,
    d: "M7.44773 9.20461C6.68782 9.40484 5.97487 9.75302 5.34973 10.2292C4.72458 10.7054 4.19952 11.3002 3.8046 11.9796C3.41013 12.6558 3.15403 13.4037 3.05119 14.1798C2.94834 14.9559 3.00081 15.7446 3.20554 16.5002L12.0002 9.79899C10.6209 9.00713 8.98415 8.79344 7.44773 9.20461Z",
    fill: "#3C782C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.0001 9.74979C11.9921 8.17342 12.591 6.65443 13.6726 5.50761C14.189 4.95307 14.8142 4.51083 15.509 4.20844C16.2039 3.90606 16.9535 3.75 17.7113 3.75C18.4691 3.75 19.2188 3.90606 19.9136 4.20844C20.6085 4.51083 21.2336 4.95307 21.7501 5.50761L12.0001 9.74979Z",
    stroke: "#3C782C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12 9.79867C13.3777 9.00843 15.0117 8.79419 16.5465 9.20257C18.0814 9.61094 19.3928 10.6089 20.1956 11.9793C20.5901 12.6555 20.8462 13.4034 20.949 14.1795C21.0519 14.9555 20.9994 15.7443 20.7947 16.4999L12 9.79867Z",
    stroke: "#3C782C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12 9.74979C12.008 8.17342 11.4091 6.65443 10.3275 5.50761C9.81104 4.95307 9.18591 4.51083 8.49106 4.20844C7.79621 3.90606 7.04654 3.75 6.28875 3.75C5.53096 3.75 4.78129 3.90606 4.08644 4.20844C3.39159 4.51083 2.76646 4.95307 2.25 5.50761L12 9.74979Z",
    stroke: "#3C782C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.0002 9.79867C10.6225 9.00843 8.98854 8.79419 7.4537 9.20257C5.91887 9.61094 4.60739 10.6089 3.8046 11.9793C3.41013 12.6555 3.15403 13.4034 3.05119 14.1795C2.94834 14.9555 3.00081 15.7443 3.20554 16.4999L12.0002 9.79867Z",
    stroke: "#3C782C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12 9.79883V21.0001",
    stroke: "#3C782C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreePalm);
export default __webpack_public_path__ + "static/media/TreePalm.6b108b3f29de9dceaa03188834cadb63.svg";
export { ForwardRef as ReactComponent };